import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { activeNetworkSelector, userSelector } from '../redux/selectors';
import { authenticateExtension } from '../services/chromeExtension';

// Silently hand the current platform JWT to the browser extension so a stuck
// install can re-authenticate itself (GET-440). Runs for every logged-in user
// with the extension, independent of LinkedIn sync. Fires once per logged-in
// user (tracked by id, reset on logout) so a re-login in the same tab still
// re-authenticates without a full page reload.
export const useAuthenticateExtension = () => {
  const user = useSelector(userSelector);
  const activeNetwork = useSelector(activeNetworkSelector);
  const authenticatedUserId = useRef(null);

  useEffect(() => {
    if (!user?.id) {
      authenticatedUserId.current = null;
      return;
    }

    if (!activeNetwork?.id || authenticatedUserId.current === user.id) {
      return;
    }

    authenticatedUserId.current = user.id;
    authenticateExtension(user, activeNetwork.id);
  }, [user, activeNetwork?.id]);
};
